import React, {useEffect, useState} from 'react';
import './NewCampaignsManagement.css'
import { NewCampaignIcon, SecretTipRed } from "@/react_app/img/Icons";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Image } from "primereact/image";
import { CampaignStatus } from "@/data/types";
import { formatDate } from '@/utils/globals/date-utils';
import { compactNumber } from '@/utils/globals/curency-utils';

const campaignManagementTabs = [
  { value: 'All', type: 'all' },
  { value: 'Active', type: 'active' },
  { value: 'Drafts', type: 'draft' },
  { value: 'Completed', type: 'completed' },
  { value: 'Pending', type: 'pending' },
];

const campaignBodyTemplate = (rowData) => {
  return (
    <div className={'campaignTemplate'}>
      <Image src={rowData.photo} alt={'campaign cover'} className={'campaignTemplateImage'}/>
      <div className={'campaignTemplateText'}>
        <p className={'campaignTemplateTitle'}>{rowData.name}</p>
        <p className={'campaignTemplateDescription'}>{rowData.productName}</p>
      </div>
    </div>
  );
};

const statusBodyTemplate = (rowData) => {
  return (
    <div className={'statusTemplate'}>
      {rowData.status === CampaignStatus.Active &&
        <div className={'statusTemplateBox statusActive'} >
          Active
        </div>
      }
      {rowData.status === CampaignStatus.Draft &&
        <div className={'statusTemplateBox statusDraft'} >
          Draft
        </div>
      }
      {rowData.status === CampaignStatus.Completed &&
        <div className={'statusTemplateBox statusCompleted'} >
          Completed
        </div>
      }
      {rowData.status === 'pending' &&
        <div className={'statusTemplateBox statusDraft'} >
          Pending
        </div>
      }
    </div>
  );
};

const marketBodyTemplate = (rowData) => {
  return (
    <div className={'marketTemplate'}>
      {rowData.targetMarket.title}
    </div>
  );
};

const dateBodyTemplate = (rowData) => {
  return (
    <div className={'dateTemplate'}>
      {rowData.dates.endDate ?
        formatDate(rowData.dates.endDate) :
        '—'
      }
    </div>
  );
};

const priceBodyTemplate = (rowData) => {
  return (
    <div className={'priceTemplate'}>
      {compactNumber(rowData.budget.amount)}{' '}{rowData.budget.currency}
    </div>
  );
};

export default function(props) {
  const [activeTab, setActiveTab] = useState(0);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    props.selectStatusCategory(campaignManagementTabs[activeTab].type);
    setSearchValue('');
  }, [activeTab]);

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    props.searchValueChange(e.target.value);
  }

  return (
    <div className={'campaigns-management'}>
      <p className={'pageTitle'}>Campaign Management</p>
      <div className={'topLayer'}>
        <div className={'newCampaignSquare'}>
          <NewCampaignIcon/>
          <p className={'newCampaignText'}>Create a new campaign and promote your game!</p>
          <Button className={'newCampaignButton'} onClick={() => props.newCampaignClick()}>New campaign</Button>
        </div>
        <div className={'newCampaignSquareMobile'}>
          <Button className={'newCampaignButton'} onClick={() => props.newCampaignClick()}>New campaign</Button>
        </div>
        <div className={'topLayerLeft'}>
          <div className={'statsWrapper'}>
            <div className={'statsSquare'}>
              <p className={'statsNumber'}>{props.counters?.campaigns}</p>
              <p className={'statsText'}>Active Campaigns</p>
            </div>
            <div className={'statsSquare'}>
              <p className={'statsNumber'}>{props.counters?.applications}</p>
              <p className={'statsText'}>Influencer Applications</p>
            </div>
            <div className={'statsSquare'}>
              <p className={'statsNumber'}>{props.counters?.contracts}</p>
              <p className={'statsText'}>Submissions</p>
            </div>
          </div>
          <div className={'secretTip'}>
            <div className={'secretTipTop'}>
              <SecretTipRed/>
              <p className={'secretTipTitle'}>Get the best of your campaign!</p>
            </div>
            <p className={'secretTipText'}>To create an effective campaign and attract the best content creators, check
              out our <a className={'secretTipLink'}>5-step guide</a> on how to create a scalable campaign on G.IO.</p>
          </div>
        </div>
      </div>
      <div>
        <div className={'tabsWrapper'}>
          <div className={'tabs'}>
            {campaignManagementTabs.map((item, index) =>
              <div key={index} className={index === activeTab ? 'tabSelected' : 'tabNormal'} onClick={() => setActiveTab(index)}>
                {item.value}
              </div>)}
          </div>
        </div>
        <div className={'campaignsSearchBarWrapper'}>
          <i className="pi pi-search" style={{ position: 'absolute', left: '11px', top: '10px' }}/>
          <InputText className={'campaignsSearchBar'} placeholder={'Search for campaign or contract'} value={searchValue} onChange={(e) => handleSearch(e)}/>
        </div>
      </div>
      <DataTable value={props.filteredCampaigns} removableSort emptyMessage={"No campaigns found."} onRowClick={(e) => props.goToCampaign(e.data.id)}>
        <Column field={"name"} header={"Campaign"} body={campaignBodyTemplate} sortable style={{ width: '40%' }}></Column>
        <Column field={"status"} header={"Status"} body={statusBodyTemplate} sortable style={{ width: '15%' }}></Column>
        <Column field={"targetMarket.title"} header={"Market"} body={marketBodyTemplate} sortable style={{ width: '15%' }}></Column>
        <Column field={"dates.endDate"} header={"Time Left"} body={dateBodyTemplate} sortable style={{ width: '15%' }}></Column>
        <Column field={"budget.amount"} header={"Price"} body={priceBodyTemplate} sortable style={{ width: '15%' }}></Column>
      </DataTable>
    </div>
  )
}
